import React, { useEffect, useState } from "react";
import UseContext from "hooks/useContext";

const CounterEquipe = () => {
    const {
        staffData,
        setStaff,
        setStandby,
        rest,
        setRest,
        refreshStaff,
    } = UseContext();

    useEffect(() => {
        console.log('CounterEquipe - staffData:', staffData);
        console.log('CounterEquipe - staffData type:', typeof staffData);
        console.log('CounterEquipe - staffData is array:', Array.isArray(staffData));
        let nbStaff = 0;
        let nbStandby = 0;

        if (staffData && Array.isArray(staffData)) {
        for (let arg in staffData) {
            if (staffData[arg].validation === 2) {
                nbStaff += 1;
            } else {
                nbStandby += 1;
                }
            }
        }

        setStaff(nbStaff);
        setStandby(nbStandby);
    setRest(10 - (nbStaff + nbStandby));
  }, [staffData, refreshStaff, setRest, setStaff, setStandby]);

    return (
        <>
      <div className="grid grid-cols-1 tab:grid-cols-3 gap-4 w-full">
        <div className="bg-gray-50 border border-gray-200 flex flex-col items-start rounded-lg px-6 py-5">
          <p className="text-sm font-medium text-gray-700">Membres de l'équipe</p>
          <p className="text-3xl font-medium text-gray-900">{staffData?.length ? staffData.filter(s => s.validation === 2).length : 0}</p>
                </div>
        <div className="bg-gray-50 border border-gray-200 flex flex-col items-start rounded-lg px-6 py-5">
          <p className="text-sm font-medium text-gray-700">Invitations en attente</p>
          <p className="text-3xl font-medium text-gray-900">{staffData?.length ? staffData.filter(s => s.validation !== 2).length : 0}</p>
                </div>
        <div className="bg-gray-50 border border-gray-200 flex flex-col items-start rounded-lg px-6 py-5">
          <p className="text-sm font-medium text-gray-700">Places disponibles</p>
          <p className="text-3xl font-medium text-gray-900">{rest}</p>
                </div>
            </div>
        </>
    );
};

export default CounterEquipe;
